import PhotoModalViewController from "./photo-modal-view-controller";

class MentalHealthNavigatorCasePhotoModalViewController extends PhotoModalViewController {
  handleButtonClick() {
    const { uploadPhotoMHN } = this.appData;
    uploadPhotoMHN();
  }
}
export default MentalHealthNavigatorCasePhotoModalViewController;
